import React from 'react'
import { FaShoppingBag, FaRocket } from 'react-icons/fa';
import { GiFilmSpool } from 'react-icons/gi'; // Reel-like icon for customer support
import { Link } from 'react-router-dom';

const Footer = () => {
    return (

        <footer className="bg-black text-white py-10">
            <div className="container mx-auto px-6">
               
                {/* <!-- Bottom Section --> */}
                <div className="text-center grid grid-cols-1 md:grid-cols-4 gap-6 text-sm">
                    <div>
                        <h3 className="uppercase font-semibold mb-4">About</h3>
                        <ul className="space-y-2">
                            <li><Link to={"/"} className="hover:text-gray-400">Kashika The shining one</Link></li>
                            <li><Link to={"/about"} className="hover:text-gray-400">About Us</Link></li>
                            <li><Link to={"/contact"} className="hover:text-gray-400">Contact Us</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="uppercase font-semibold mb-4">Shop</h3>
                        <ul className="space-y-2">
                            <li><Link to={"/cart"} className="hover:text-gray-400">Cart</Link></li>
                            <li><a href="#" className="hover:text-gray-400">Wishlist</a></li>
                            <li><Link to={"/shop"} className="hover:text-gray-400">Shop Collections</Link></li>
                            
                        </ul>
                    </div>
                    <div>
                        <h3 className="uppercase font-semibold mb-4">Legal</h3>
                        <ul className="space-y-2">
                            <li><a href="#" className="hover:text-gray-400">Terms & Conditions</a></li>
                            <li><a href="#" className="hover:text-gray-400">Privacy Policy</a></li>
                            <li><a href="#" className="hover:text-gray-400">Refunds Policy</a></li>
                            <li><a href="#" className="hover:text-gray-400">Shipping Policy</a></li>
        
                        </ul>
                    </div>
                    <div>
                        <h3 className="uppercase font-semibold mb-4">Contact Us</h3>
                        <ul className="space-y-2">
                            <li><a href="tel:+91789654123" className="hover:text-gray-400">+1-7039263351</a></li>
                            <li><a href="mailto:care@test.com" className="hover:text-gray-400">Kashikatheshiningone@gmail.com</a></li>
                            <li>
                                Copper Tree Terr, Ashburn, Virginia,<br />
                                20148, USA.
                            </li>
                        </ul>
                    </div>
                </div>

                {/* <!-- Bottom Bar --> */}
                <div className="text-center text-gray-400 mt-10 border-t border-gray-600 pt-4 text-xs">
                    <p>© Kashika The Shining One • All rights reserved.</p>
                    {/* <p>webWorks by: <a href="#" className="text-white hover:text-gray-400">Rajnish</a></p> */}
                </div>
            </div>
        </footer>


    )
}

export default Footer